import React from 'react'
import SignupForm from '../Pages/SignUp/Signup'

function SignUp() {
  return (
    <>
        <SignupForm />
    </>
  )
}

export default SignUp
